import * as THREE from 'three'
import useCamera from '~/composables/configurator/useCamera'
import useSizes from '~/composables/configurator/useSizes'
import { sources } from '~/service/experience/sources'
import { useAccumulativeShadows } from '~/service/experience/utils/AccumulativeShadows'
import Resources from '~/service/experience/utils/Resources'

let canvas: HTMLCanvasElement
let sizes = useSizes()
let time: ReturnType<typeof useTime>
let scene: THREE.Scene = new THREE.Scene()
let camera: ReturnType<typeof useCamera>
let renderer: ReturnType<typeof useRenderer>
let world: ReturnType<typeof useWorld>
let raycaster: ReturnType<typeof useRaycaster>
let resources: Resources

export default function useConfigurator() {
  // Setup
  scene.background = new THREE.Color('#fff')

  async function setResources(json: string | null) {
    if (json) {
      const parsed: { nidos: [] } = JSON.parse(json)

      parsed.nidos.forEach((nidoStr: string) => {
        const nido = JSON.parse(nidoStr)
        Object.values(nido.parts).map((part) => {
          if (part.textureId) {
            sources.push({
              name: part.textureId,
              path: part.textureId,
              type: 'texture',
            })
          }
          if (part.lowBackrest) {
            sources.push({
              name: part.lowBackrest.textureId,
              path: part.lowBackrest.textureId,
              type: 'texture',
            })
            if (part.lowBackrest.highBackrest) {
              sources.push({
                name: part.lowBackrest.highBackrest.textureId,
                path: part.lowBackrest.highBackrest.textureId,
                type: 'texture',
              })
            }
            if (part.lowBackrest.pillow) {
              sources.push({
                name: part.lowBackrest.pillow.textureId,
                path: part.lowBackrest.pillow.textureId,
                type: 'texture',
              })
            }
          }
        })
      })
    }

    resources = new Resources(sources)

    await resources.loadSurfaces()
    resources.startLoading()
  }

  function setMembers(canvasElement?: HTMLCanvasElement) {
    if (!canvasElement) return

    canvas = canvasElement

    camera = useCamera(canvas, scene)
    renderer = useRenderer(canvas, scene, resources)

    renderer.initProgressiveShadows()
    // renderer.initProgressiveShadows()
    time = useTime()

    world = useWorld(scene, resources)

    raycaster = useRaycaster()
    raycaster.init()

    // world.on('addedChair', () => {
    //   // renderer.progressiveShadows.recalculate()
    //   useAccumulativeShadows(renderer.instance, scene, camera.instance).reset()

    //   if (world.scalesVisible) {
    //     world.removeScales()
    //     world.addScales()
    //   }
    //   raycaster.checkPoints()
    // })

    // world.on('updatedPoints', () => {
    //   raycaster.checkPoints()
    // })
  }

  function addedChair() {
    renderer.resetShadows()
    if (useWorld().scalesVisible) {
      world.removeScales()
      world.addScales()
    }
    raycaster.checkPoints()
  }

  function destroy() {
    time.stop()

    scene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose()

        for (const key in child.material) {
          const value = child.material[key]
          if (value && typeof value.dispose === 'function') {
            value.dispose()
          }
        }
      }
      if (child instanceof THREE.Light) {
        child.dispose()
      }
    })

    scene.remove(...scene.children)

    raycaster.destroy()
    world.destroy()
    camera.controls.dispose()
    renderer.destroy()
  }

  function getResources() {
    return resources
  }

  function getScene() {
    return scene
  }

  function getCanvas() {
    return canvas
  }

  return {
    setMembers,
    setResources,
    destroy,
    addedChair,
    getResources,
    getScene,
    scene,
    getCanvas,
  }
}
